import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({ settings: {}, refresh: () => {} });

const DEFAULTS = {
  linkedin_dataleo_url: "",
  linkedin_jfn_url: "",
  substack_url: "",
  contact_email: "contact@dataleo.com",
  phone: "",
  address_street: "",
  address_city: "",
  address_postal_code: "",
  address_country: "",
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = () => {
    api
      .get("/settings")
      .then((r) => setSettings({ ...DEFAULTS, ...r.data }))
      .catch(() => {});
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
